import { Data, HistoryNode } from '../../features/history/common/interface'

export const traverse = <T extends Data>(
  nodes: HistoryNode<T>[],
  globalFilter: string,
  setNodes: (value: Record<string, boolean>) => void,
) => {
  const keysToExpand: Record<string, boolean> = {}
  const traverseNodes = (nodes: HistoryNode<T>[]) => {
    nodes.forEach(node => {
      if (node.children && node.children.length > 0) {
        if (globalFilter) keysToExpand[node.key!] = true
        else {
          if (keysToExpand[node.key!]) delete keysToExpand[node.key!]
        }
        traverseNodes(node.children)
      }
    })
  }
  traverseNodes(nodes)
  setNodes(keysToExpand)
}
